<span [class.no-deadline]="!deadline" class="deadline-container" matTooltip="Deadline">
  <mat-icon class="small-icon">calendar_month</mat-icon>
  {{deadline | date:'y-MM-dd'}}
</span>
